import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import BookWorldListComponent from './BookWorldListComponent';
import './styles/BookShelf.css'; 
import BWButtons from './BookWorldButton';
import adImage from '../../assets/pageimages/bookworldlistad.webp';

const BookWorld = () => {
    const navigate = useNavigate();
    const [param1, setParam1] = useState('f');
    const [param2, setParam2] = useState('think5whys');
    const [hoveredButton, setHoveredButton] = useState(null);
    const [activeButton, setActiveButton] = useState(null);

    const handleHover = (buttonId) => {
        setHoveredButton(buttonId);
    };

    const handleBlur = () => {
        setHoveredButton(null);
    };

    const setSearch = (p1, p2) => {
        setParam1(p1);
        setParam2(p2);
    };

    useEffect(() => {
        // Any additional logic if needed
    }, [param1, param2]);

    const handleClick = (action, id) => {
        if (action.startsWith('setSearch')) {
            const params = action.match(/\(([^)]+)\)/)[1].split(',').map(param => param.trim().replace(/['"]/g, ''));
            const [p1, p2] = params;
            setSearch(p1, p2);
        } else if (action.startsWith('navigate')) {
            const path = action.match(/\(([^)]+)\)/)[1].replace(/['"]/g, '');
            navigate(path);
        }
        setActiveButton(id);
    };

    return (
        <div>
            <div className="min-h-screen py-8 bg-black border-b border-blue-400">
                <h2 className='text-xl font-bold text-yellow-200 text-center'>Think5Whys 360 Degree Digital BookWorld</h2>
                <div className="flex flex-col justify-center">
                    <h1 className='text-m mt-1 text-cyan-300 flex justify-center align-middle'>
                        An Innovative Digital Platform for Learners, Authors, Publishers, Educational Trusts, NGOs, Corporate Learners, Digital Schools / Universities
                    </h1>
                </div>
                <div className="flex justify-center mt-2 mb-2">
                    <img className="align-middle" src={adImage} alt="Ad" />
                </div>
                <div>
                    <p className='text-sm lg:text-m mt-1 mb-2 text-white flex justify-center text-center'>
                        Select The Desired Button To Explore Available Books On Think5Whys Store 
                    </p>
                </div>
                <div className="bw-button-container">
                    {BWButtons.map((button) => (
                        <div key={button.id}>
                            <button
                                id={button.id}
                                className={`button-style ${button.className || ''}`}
                                style={{
                                    backgroundColor: hoveredButton === button.id ? button.hoverBackgroundColor : button.backgroundColor,
                                    color: hoveredButton === button.id ? button.hoverColor : button.color
                                }}
                                onClick={() => handleClick(button.onClick, button.id)}
                                onMouseEnter={() => handleHover(button.id)}
                                onMouseLeave={handleBlur}
                                onFocus={() => handleHover(button.id)}
                                onBlur={handleBlur}
                            >
                                {button.text}
                            </button>
                            {activeButton === button.id && (
                                <div className="full-width-container">
                                    <BookWorldListComponent param1={param1} param2={param2} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            <footer className="sticky bg-black border-t border-blue-400 text-white py-2 px-4 mt-2">
                <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
                    <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
                    <div className="flex flex-wrap justify-center md:justify-start gap-2 sm:gap-6 text-xs sm:text-sm">
                        <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
                        <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
                        <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
                        <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default BookWorld;
